import { Directive, ElementRef, OnInit, HostListener, Input } from '@angular/core';

/** */
@Directive({
    selector: '[tsl-ssn-mask]'
})
export class SSNDirectives implements OnInit {

    private el: HTMLInputElement;

    @Input('tsl-taxType') taxType: string = '';
    
    constructor(private elementRef: ElementRef) { }

    ngOnInit() {
        this.el = this.elementRef.nativeElement;
    }


    @HostListener("blur", [])
    onblur() {
        if (this.taxType) {
            if (this.taxType.toLowerCase() == "ssn") {
                if (this.el.value.length >= 11) {
                    var regex = new RegExp(/^[0-9]{3}-[0-9]{2}-[0-9]{4}$/g);
                    if (!regex.test(this.el.value)) {
                        var val = this.el.value;
                        val = val.replace(/[-]/g, '');
                        if (val.length > 3) {
                            this.el.value = val.substr(0, 3) + "-" + val.substr(3, 2);
                        }
                        if (val.length > 5) {
                            this.el.value = val.substr(0, 3) + "-" + val.substr(3, 2) + "-" + val.substr(5, 4);
                        }
                    }
                }
            }
            else if (this.taxType.toLowerCase() == "ein") {
                if (this.el.value.length >= 10) {
                    var regex = new RegExp(/^[0-9]{2}-[0-9]{7}$/g);
                    if (!regex.test(this.el.value)) {
                        var val = this.el.value;
                        val = val.replace(/[-]/g, '');
                        if (val.length > 2) {
                            this.el.value = val.substr(0, 2) + "-" + val.substr(2, 7);
                        }
                    }
                }
            } 
            else if (this.taxType.toLowerCase() == "pan") {
                if (this.el.value.length >= 10) {
                    var regex = new RegExp(/^[0-9a-zA-Z]{10}$/g);
                }
            }
            else if (this.taxType.toLowerCase() == "tnumber")
            {
                if (this.el.value.length >= 14) {
                    var regex = new RegExp(/^[T]/mg);
                }
            }
        }
    }


    @HostListener("keydown", ['$event'])
    onkeydown(event: KeyboardEvent) {
        var allowedKeys = [8, 35, 36, 37, 38, 39, 40];
        if (this.taxType) {
            if (this.taxType.toLowerCase() == "ein") {
                if (this.el.value.length == 10) {
                    if (allowedKeys.indexOf(event.which) == -1) {
                        event.preventDefault();
                    }
                }
            }
            else if (this.taxType.toLowerCase() == "ssn") {
                if (this.el.value.length == 11) {
                    if (allowedKeys.indexOf(event.which) == -1) {
                        event.preventDefault();
                    }
                }
            }
            else if (this.taxType.toLowerCase() == "pan") {
                if (this.el.value.length == 10) {
                    if (allowedKeys.indexOf(event.which) == -1) {
                        event.preventDefault();
                    }
                }
            }
            else if (this.taxType.toLowerCase() == "tnumber")
            {
                if (this.el.value.length == 14) {
                    if (allowedKeys.indexOf(event.which) == -1) {
                        event.preventDefault();
                    }
                }
            }
            else if(this.taxType.toLowerCase() == "qid")
            {
                if (this.el.value.length == 11) {
                    if (allowedKeys.indexOf(event.which) == -1) {
                        event.preventDefault();
                    }
                }
            }

        }
        else {
            event.preventDefault();
        }
    }


    @HostListener("keyup", ['$event'])
    onkeyup(event: KeyboardEvent) {
        if (this.taxType) {

            let taxIdType = ["pan", "tnumber" , "commreg" , "tin", "qid"];

            // This method is to format the text string based on Tax Type 
            // For e.g for SSN -> ABC-DFE-GHIJ
            if (this.taxType.toLowerCase() == "ssn") {
                var val = this.el.value;
                val = val.replace(/[^0-9]/g, '');
                this.el.value = val;
                if (val.length > 3) {
                    this.el.value = val.substr(0, 3) + "-" + val.substr(3, 2);
                }
                if (val.length > 5) {
                    this.el.value = val.substr(0, 3) + "-" + val.substr(3, 2) + "-" + val.substr(5, 4);
                }
                if (val == '') {
                    this.el.value = val;
                }
            }
            else if (this.taxType.toLowerCase() == "ein") {
                var val = this.el.value;
                val = val.replace(/[^0-9]/g, '');
                this.el.value = val;
                if (val.length > 2) {
                    this.el.value = val.substr(0, 2) + "-" + val.substr(2, 7);
                }
                if (val == '') {
                    this.el.value = val;
                }
            }
            else if (taxIdType.includes(this.taxType.toLowerCase())) {
                var val = this.el.value;
            }
        }
    }
}